export const apiConfig = {
  baseUrl: (import.meta.env.VITE_API_URL as string) || '/api',
  timeoutMs: 10000,
};
